import Model from 'flarum/common/Model';
export default class ErasureRequest extends Model {
  status() {
    return Model.attribute('status').call(this);
  }
  reason() {
    return Model.attribute('reason').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  userConfirmedAt() {
    return Model.attribute('userConfirmedAt', Model.transformDate).call(this);
  }
  processedAt() {
    return Model.attribute('processedAt', Model.transformDate).call(this);
  }
  processorComment() {
    return Model.attribute('processorComment').call(this);
  }
  processedMode() {
    return Model.attribute('processedMode').call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  processedBy() {
    return Model.hasOne('processedBy').call(this);
  }
}
flarum.reg.add('flarum-gdpr', 'common/models/ErasureRequest', ErasureRequest);